var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-head"},[_vm._t("default"),_c('span',{ref:"line",staticClass:"line",attrs:{"id":"g-line"}}),_c('div',{staticClass:"button-wrapper"},[_vm._t("button")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }